import styled from 'styled-components';
import { ReactComponent as PlusImage } from 'Images/icon-action-bar-plus.svg';
import Button from '../Button';
import { typography } from '../tokens';

export const PlusIcon = styled(PlusImage)`
  height: 12px;
  & path {
    fill: ${({ theme }) => theme.buttons.addButton.color};
  }
`;
PlusIcon.displayName = 'PlusIcon';

export const StyledAddButton = styled(Button).attrs({ variant: 'secondary' })`
  && {
    background-color: ${({ theme }) => theme.buttons.addButton.background};
    border-color: ${({ theme }) => theme.buttons.addButton.border};
    color: ${({ theme }) => theme.buttons.addButton.color};
    font-size: ${typography.fontSize.sm};

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.buttons.addButton.backgroundHover};
    }
  }
`;
StyledAddButton.displayName = 'StyledAddButton';
